module.exports = __webpack_public_path__ + "src/img/marleyspoon/marleyspoon-image-3.96f3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/marleyspoon/marleyspoon-image-3.png
// module id = 253
// module chunks = 0